//import axios from "./Config/axios"
import axios from "axios"
/*import  SMN from "../Config/axios"


export function getByLatLonSMN(){
    
    return SMN.get(``)
}*/
export function getByLatLon(lat, lon){
  try{
    return axios.create({
        baseURL: "https://api.tutiempo.net/",method: 'HEAD',
		//mode: 'no-cors'
    }).get(`json/?lan=es&apid=qwEXaz44a4a4xN4&ll=${lat},${lon}`)
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log('Error response.data ', error.response.data);
      console.log('Error response.status ', error.response.status);
      console.log('Error response.headers ', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log('Error request ', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Errorr ', error.message);
    }
    console.log('Error config ', error.config);
  }
}
export function getAlertByLatLon(){
    try {
    return axios.create({
      //    baseURL: "https://ssl.smn.gob.ar/feeds/"
    //baseURL: 'https://meridianodigital.com.ar/cacho/'
     baseURL:"/cacho/"
    // baseURL:"/"
     // ,credentials: false
      ,

      method: 'HEAD',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      //mode: 'no-cors'
    }).get(`avisocorto_GeoRSS.xml`)
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log('Error response.data ', error.response.data);
      console.log('Error response.status ', error.response.status);
      console.log('Error response.headers ', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log('Error request ', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Errorr ', error.message);
    }
    console.log('Error config ', error.config);
  }
}